import React from 'react';
import './TemplateActionBar.css';

export default function TemplateActionBar({
  templateType,
  onCancel,
  onSave,
  onReset,
  isPreviewMode,
  onTogglePreview,
  error,
  success
}) {
  const templateName = templateType === 'estimate' ? 'Estimate' : 
                       templateType === 'invoice' ? 'Invoice' : 'Letter';

  return (
    <div className="template-action-bar">
      <div className="action-bar-left">
        <h2 className="action-bar-title">Edit {templateName} Template</h2>
      </div>
      
      <div className="action-bar-right">
        {error && (
          <div className="action-bar-message error">{error}</div>
        )}
        {success && (
          <div className="action-bar-message success">{success}</div>
        )}
        
        <button
          type="button"
          className="btn-action btn-preview-toggle"
          onClick={onTogglePreview}
        >
          {isPreviewMode ? '📝 Editor' : '👁 Preview PDF'}
        </button>
        
        {onReset && (
          <button
            type="button"
            className="btn-action btn-secondary"
            onClick={onReset}
          >
            Reset to Default
          </button>
        )}
        
        <button
          type="button"
          className="btn-action btn-secondary"
          onClick={onCancel}
        >
          Cancel
        </button>
        
        <button
          type="button"
          className="btn-action btn-primary"
          onClick={onSave}
        >
          Save Template
        </button>
      </div>
    </div>
  );
}
